import React, { createContext, useContext, useEffect } from "react";

type DesignVersion = "v2";

interface DesignVersionContextType {
    version: DesignVersion;
}

const DesignVersionContext = createContext<DesignVersionContextType | null>(null);

export const DesignVersionProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const version: DesignVersion = "v2";

    useEffect(() => {
        document.documentElement.dataset.designVersion = version;
    }, []);

    return <DesignVersionContext.Provider value={{ version }}>{children}</DesignVersionContext.Provider>;
};

export const useDesignVersion = (): DesignVersionContextType => {
    const context = useContext(DesignVersionContext);
    if (!context) {
        throw new Error("useDesignVersion must be used within a DesignVersionProvider");
    }
    return context;
};
